<template>
  <Line
    id="my-chart-id"
    :options="chartOptions"
    :data="chartData"
    ref="myLineChart"
  />
</template>

<script>
import 'chartjs-adapter-moment'
import {Line} from 'vue-chartjs'
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'
import ChartHelper from "./ChartHelper"

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'LineChart',
  props: ['chartType', 'queryColumns', 'queryResult', 'chartZoomResetKey', 'queryID'],

  components: {Line, CategoryScale, LinearScale},
  /*
    watch: {
      chartZoomResetKey() {
        this.$refs[this.queryID].chart.resetZoom()
      }
    },
  */
  data() {
    return {
      NUMBER_CFG: {count: 7, min: 0, max: 100},

      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: false,
            text: 'Stacked scales',
          },
          zoom: {/*
              zoom: {
                wheel: { enabled: true },
                pinch: { enabled: true },
                mode: 'xy',
              },
              pan: {
                enabled: true,
                mode: 'x',
                threshold: 3
              },*/
          }
        },
        elements: {
          point: {
            radius: this.radius,
            display: true
          }
        },
        scales: {}
      }
    }
  },

  computed: {
    chartOptions() {
      let steppedAxisTemplateList = {}

      steppedAxisTemplateList["li"] = {
        type: 'linear',
        position: 'left',
        stack: 'demo',
        offset: true,
        stackWeight: 5,
        border: {
          color: 'blue'
        }
      }

      steppedAxisTemplateList["ls"] = {
        type: 'linear',
        position: 'left',
        stack: 'demo',
        offset: true,
        stackWeight: 1,
        border: {
          color: 'blue'
        }
      }

      steppedAxisTemplateList["oc"] = {
        type: 'category',
        labels: ['Open', 'Unknown', 'Close'],
        offset: true,
        position: 'left',
        stack: 'demo',
        stackWeight: 1,
        border: {
          color: 'orange'
        }
      }

      steppedAxisTemplateList["oo"] = {
        type: 'category',
        labels: ['On', 'Unknown', 'Off'],
        offset: true,
        position: 'left',
        stack: 'demo',
        stackWeight: 1,
        border: {
          color: 'red'
        }
      }

      steppedAxisTemplateList["es"] = {
        type: 'category',
        i1_name: 'es', // engine states
        labels: ['Continues', 'Start|Stop', 'Cycle sentry', 'Sleep', 'Off'],
        offset: true,
        position: 'left',
        stack: 'demo',
        stackWeight: 1,
        border: {
          color: 'green'
        }
      }

      if (this.queryResult.length > 0) {
        Object.values(this.queryResult[0]).forEach(col => {
          if (col && col.indexOf("::") != -1) {
            let axis = col.split('::')[0]
            let count = axis.slice(-1)
            let templName = axis

            // logger.info("axis count:", axis)

            if (!isNaN(count)) {
              templName = axis.substring(0, 2)
              // logger.info("new axis:", axis)
            }

            this.options.scales[axis] = steppedAxisTemplateList[templName]
          }
        })
      }

      this.options.scales.default = {
        type: 'linear',
        position: 'left',
        stack: 'demo',
        stackWeight: 5,
        border: {
          color: 'blue'
        },
        offset: true
      }

      return this.options
    },


    chartData() {
      if (this.queryResult && this.queryResult.length > 0) {
        let datasets = ChartHelper.buildDataset(this.chartType, this.queryColumns, this.queryResult)
        logger.info("Datasets:", datasets, ", len:", datasets.labels.length)

        let legendIsDate = false
        this.queryColumns.forEach((col, idx) => {
          if (col.chartIsLegend && (col.datatypeID == 21 || col.datatypeID == 22)) legendIsDate = true
        })

        if (legendIsDate) {
          if (datasets.labels && datasets.labels.length > 0) {
            logger.info("LineChart3: use time scale")
            this.options.scales.x = {
              type: 'time',
              time: {
                unit: 'hour',
                format: "HH:mm",
                stepSize: 1,
                tooltipFormat: 'HH:mm',
                displayFormats: {
                  'millisecond': 'HH:mm',
                  'second': 'HH:mm',
                  'minute': 'HH:mm',
                  'hour': 'HH:mm',
                  'day': 'HH:mm',
                  'week': 'HH:mm',
                  'month': 'HH:mm',
                  'quarter': 'HH:mm',
                  'year': 'HH:mm',
                },
                parser: 'YYYY-MM-DDTHH:mm:ss',
              }
            }
          }
        }

        return datasets
      }
    }
  },

  methods: {
    radius(context) {
      // logger.info("radius. ", context.dataIndex, "==", this.selDataRowIdx, context.raw.x)
      if (context.raw.x == this.selDataRowIdx) {
        return 8
      } else {
        return 1
      }
    },

    isDateFormatValid(dateString) {
      var date = new Date(dateString);
      return !isNaN(date.getTime());
    },

    queryRowSelEventReceiver({senderQueryID, col, value}) {
      //logger.info("LINECHART - queryRowSelEventReceiver.", col, value)

      for (let i = 0; i < this.queryColumns.length; i++) {
        if (this.queryColumns[i].nullValueReplacement && this.queryColumns[i].nullValueReplacement.includes("::EVENT_RECEIVER")) {
          for (let r = 0; r < this.queryResult.length; r++) {
            if (Object.values(this.queryResult[r])[i] == value) {
              logger.info(Object.values(this.queryResult[r])[i])

              // this.selDataRowIdx = r
              this.selDataRowIdx = Object.values(this.queryResult[r])[i]

              let chartInstance = this.$refs.myLineChart.chart
              chartInstance.update()
              break
            }
          }
          break
        }
      }
    }
  },

  beforeUnmount: function () {
    this.eventBus.off("onQueryRowSel", this.queryRowSelEventReceiver)
  },

  mounted: function () {
    logger.info("Mount Linechart!")
    this.eventBus.on("onQueryRowSel", this.queryRowSelEventReceiver)
  }

}
</script>
